document.querySelectorAll('[data-pdp-stickybar]').forEach(function (bar) {
  var heroForm = document.querySelector('[data-pdp-form]');
  var heroAtc = document.querySelector('[data-pdp-atc]');
  var heroPackInputs = document.querySelectorAll('[data-pdp-pack-input]');
  var heroPurchaseRow = document.querySelector('[data-pdp-purchase-row]');

  if (!heroForm || !heroAtc) return;

  bar.hidden = false;

  function formatMoney(cents) {
    return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
  }

  var currentPriceEl = bar.querySelector('[data-pdp-stickybar-current-price]');
  var comparePriceEl = bar.querySelector('[data-pdp-stickybar-compare-price]');
  var priceWrap = bar.querySelector('[data-pdp-stickybar-price]');

  function setPrice(price, comparePrice) {
    // Number() is load-bearing: these arrive as data-attribute strings,
    // and "10000" > "9500" is false when they are compared as text.
    var p = Number(price || 0);
    var cp = Number(comparePrice || 0);
    if (currentPriceEl) currentPriceEl.textContent = formatMoney(p);
    if (priceWrap) {
      if (cp > p) {
        if (!comparePriceEl) {
          comparePriceEl = document.createElement('s');
          comparePriceEl.className = 'pdp-stickybar__price-compare';
          comparePriceEl.setAttribute('data-pdp-stickybar-compare-price', '');
          priceWrap.insertBefore(comparePriceEl, priceWrap.firstChild);
        }
        comparePriceEl.textContent = formatMoney(cp);
        comparePriceEl.hidden = false;
      } else if (comparePriceEl) {
        comparePriceEl.hidden = true;
      }
    }
  }

  bar.querySelectorAll('[data-pdp-stickybar-pack-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      bar.querySelectorAll('.pdp-stickybar__pack-pill').forEach(function (pill) { pill.classList.remove('is-active'); });
      input.closest('.pdp-stickybar__pack-pill').classList.add('is-active');
      setPrice(input.dataset.price, input.dataset.comparePrice);

      var match = Array.prototype.filter.call(heroPackInputs, function (heroInput) {
        return heroInput.value === input.value;
      })[0];
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  heroPackInputs.forEach(function (heroInput) {
    heroInput.addEventListener('change', function () {
      var match = bar.querySelector('[data-pdp-stickybar-pack-input][value="' + heroInput.value + '"]');
      if (match && !match.checked) {
        match.checked = true;
        bar.querySelectorAll('.pdp-stickybar__pack-pill').forEach(function (pill) { pill.classList.remove('is-active'); });
        match.closest('.pdp-stickybar__pack-pill').classList.add('is-active');
        setPrice(heroInput.dataset.price, heroInput.dataset.comparePrice);
      }
    });
  });

  var barAtc = bar.querySelector('[data-pdp-stickybar-atc]');
  if (barAtc) {
    barAtc.addEventListener('click', function () {
      if (typeof heroForm.requestSubmit === 'function') {
        heroForm.requestSubmit(heroAtc);
      } else {
        heroAtc.click();
      }
    });
  }

  if (heroPurchaseRow && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    }, { threshold: 0 });
    observer.observe(heroPurchaseRow);
  }
});
